module.exports = __webpack_public_path__ + "static/img/banner-矿山全场景AI视频识别解决方案.f39c7d96.webp";